'use client';

import { c as _c } from "react/compiler-runtime";
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { BudgetEstimateCard } from './budget-estimate-card';
import { PaymentTermsCard } from './payment-terms-card';
import { RoadmapCard } from './roadmap-card';
interface StatCardsProps {
  milestones: number;
  deliverables: number;
  totalBudget: number;
}
function StatCards(t0) {
  const $ = _c(22);
  const {
    milestones,
    deliverables,
    totalBudget
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [Navigation];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== deliverables || $[2] !== milestones) {
    t2 = <SwiperSlide><div className="h-31.5 px-5 sm:px-10 [&>*:first-child]:h-full"><RoadmapCard milestones={milestones} deliverables={deliverables} /></div></SwiperSlide>;
    $[1] = deliverables;
    $[2] = milestones;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== totalBudget) {
    t3 = <SwiperSlide><div className="h-31.5 px-5 sm:px-10 [&>*:first-child]:h-full"><BudgetEstimateCard totalBudget={totalBudget} /></div></SwiperSlide>;
    $[4] = totalBudget;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SwiperSlide><div className="h-31.5 px-5 sm:px-10 [&>*:first-child]:h-full"><PaymentTermsCard /></div></SwiperSlide>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3) {
    t5 = <div className="md:hidden"><Swiper navigation={true} modules={t1}>{t2}{t3}{t4}</Swiper></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== deliverables || $[11] !== milestones) {
    t6 = <RoadmapCard milestones={milestones} deliverables={deliverables} />;
    $[10] = deliverables;
    $[11] = milestones;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== totalBudget) {
    t7 = <BudgetEstimateCard totalBudget={totalBudget} />;
    $[13] = totalBudget;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <PaymentTermsCard />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7) {
    t9 = <div className="hidden grid-cols-1 gap-2 md:grid md:grid-cols-2 md:gap-4 lg:grid-cols-3 lg:gap-6 md:[&>*:last-child]:col-span-2 lg:[&>*:last-child]:col-span-1">{t6}{t7}{t8}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t9) {
    t10 = <>{t5}{t9}</>;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
export { StatCards };